import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { stopSubmit, clearFields } from 'redux-form'
import { image, utils } from 'services'
import store from 'services/store'

import { ReduxBrokerNote } from 'components/Forms/BrokerNote'

class ConnectedBrokerNote extends Component {
  constructor(props) {
    super(props)
    this.state = { formValues: {} }
  }

  createNote = values => {
    const directAnnonceLeadAssignation = this.props.leadId
    const { title, content } = values;
    this.props.actions.createNoteRequest({
      title,
      content,
      directAnnonceLeadAssignation
    });
    this.props.closeModal();
  }

  render() {
    return (
      <ReduxBrokerNote
        onSubmit={this.createNote}
      />
    )
  }
}

const mapStateToProps = state => ({
  noteRequestState: store.create('brokerNote').selector(state)
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      createNoteRequest: store.create('brokerNote').action,
    },
    dispatch
  )
})

export default connect(mapStateToProps, mapDispatchToProps)(
  ConnectedBrokerNote
);

